module.exports = __webpack_public_path__ + "static/media/guardians.57cbf00c.jpg";